import PortUtils from "../../portlibs/PortUtils";
import Holding from "../../models/Holding";
import useCashSummary from "../../portlibs/useCashSummary";
import Table, { TTHProps } from "../../gui/Table/Table";
import { TTDProps } from "../../gui/Table/TableCell";
import { usePath } from "../../libs/path/PathProvider";

const COLS = ["type", "ca", "us", "us_ca", "total"]

type TAssetTypes = "CASH"|"SAVE"|"GIC"|"BOND"|"EQUITY"|"DEPOSITS"|"GAINS"|"TOTAL"

const LABELS : Record<string,string> = {
    type:"ASSET",
    ca:"CA",
    us:"US",
    us_ca:"US (C$)",
    total:"TOTAL"
}

type TCashRow = {type:TAssetTypes, ca:number, us:number, us_ca:number, total:number}
function makeRow(type:TAssetTypes, ca:number, us:number, exchange:number) : TCashRow {
    return {type, ca, us, us_ca:us*exchange, total:ca + us*exchange}
}

export default function HomeTable() {
    const  { cash_ca_holding, cash_us_holding, cash_ca, cash_us, save_ca, save_us, bond_ca, bond_us, gic_ca, gic_us, equity_ca, equity_us, 
        deposit_ca, deposit_us, total_ca, total_us, usd2cad} = useCashSummary()
    
    const {setHash} = usePath()

    const onCash = (holding:Holding) => () => setHash(PortUtils.createHash(holding.id))

    const cell = (row:TCashRow, col:string) => {
        if (col=="type") return row.type
        else return PortUtils.formatCurrency(col=="USD" ? 1 : 0, (row as any)[col], false)
    }
    const cellProps = (row:TCashRow, col:string) => {
        const ret : TTDProps = {}
        const classNames : string[] = []
        if (row.type=="TOTAL") classNames.push("w700")
        else if ((row.type=="GAINS") && col!="ASSET") classNames.push((row as any)[col]<0 ? "red" : "green")

        if (col!="type") {
            classNames.push("align-right")
            if (row.type=="CASH") {
                if (col=="ca") ret.onClick = onCash(cash_ca_holding)
                else if (col=="us") ret.onClick = onCash(cash_us_holding)
            }
        }        

        if (classNames.length) ret.className = classNames.join(" ")
        return ret
    }
    const headerProps = (col:string) : TTHProps => col=="type" ? {} : {className:"align-right"}
    const label = (col:string) => LABELS[col] || col
    const gains : TCashRow = {type:"GAINS",ca:total_ca-deposit_ca,us:total_us-deposit_us,us_ca:(total_us-deposit_us)*usd2cad,total:total_ca-deposit_ca+(total_us-deposit_us)*usd2cad}
    const rows = [makeRow("CASH", cash_ca, cash_us, usd2cad), makeRow("SAVE", save_ca, save_us, usd2cad), makeRow("GIC", gic_ca, gic_us, usd2cad), makeRow("BOND", bond_ca, bond_us, usd2cad), makeRow("EQUITY", equity_ca, equity_us, usd2cad)]
    const footers = [makeRow("DEPOSITS", deposit_ca, deposit_us, usd2cad), gains, makeRow("TOTAL", total_ca, total_us, usd2cad)]
    return <Table className="home" tableName="home" disableSort={true} cols={COLS} rows={rows} cellText={cell} label={label} td={cellProps} th={headerProps} footer={footers} rowKey={row => JSON.stringify(row)}/>
}